import { getIndex } from '../mixins/utilities'
import router from '../router/index'

export const setLoading = (state, status) => {state.setLoading = status}
export const setError = (state, err) => {state.fbError = err.message}
export const signIn= state => {
  state.fbError = ""
  state.type = ""
  state.loadedItem = null
}
export const loadUser = (state, user) => {state.user = user}
export const clearUser = state => {
  state.user = null
  state.handouts = []
  state.tracks = []
  state.notes = []
  state.lessons = []
  state.students = []
  state.loadedSonglist = []
  state.loadedLessonDate = ""
  state.songlists = []
  state.type = ""
  state.greetings = []
  state.disallowedDates = []
  state.setLoading = false
}
// -----------------------------------------initialize data--------------------------------------
export const loadHandouts = (state, handouts) => {state.handouts = handouts}
export const loadTracks = (state, tracks) => {state.tracks = tracks}
export const loadFinalTracks = (state, finalTracks) => {state.finalTracks = finalTracks}
export const loadNotes = (state, notes) => {state.notes = notes}
export const loadLessons = (state, arrLesons) => {state.lessons = arrLesons}
export const loadDisallowedDates = (state, arrDisallowed) => {state.disallowedDates = arrDisallowed}
export const loadGreetings = (state, arrGreetings) => {state.greetings = arrGreetings}
export const loadStudents = (state, arrStudents) => {state.students = arrStudents}
export const loadSonglists = (state, arrSonglists) => state.songlists = arrSonglists
export const loadTargeted = (state, arrTargeted) => state.targeted = arrTargeted
export const loadSonglist = (state, objSonglist) => state.loadedSonglist= objSonglist
export const clearLoadedSonglist = state => {state.loadedSonglist = null}
export const setType = (state, type) => {state.type = type}
export const setLoc = (state, dest) => {state.location = dest}
export const setStudentName = (state, name) => {state.loadedStudentName = name}
export const clearStudentName = state => state.loadedStudentName = ""
export const clearLoadedItem = state => {state.loadedItem = null}
export const setLessonDate = (state, lessonDate) => {state.loadedLessonDate = lessonDate}


export const deleteFromSonglist = (state, idx) => {
  state.loadedSonglist.songs.splice(idx, 1)
}
export const deleteSonglist = (state, objSonglist) => {
  let idx = getIndex(state.songlists, objSonglist.docId)
  state.songlists.splice(idx, 1, objSonglist)
  router.go(-1)
}
export const editSong = (state, objSong) => {
  let idxSl
  let idxSong
  for (let i = 0; i < state.songlists.length; i++) {
    state.songlists[i].docId === objSong.docId ? idxSl = i : ""
  }

  for (let iCounter = 0; iCounter < state.songlists[idxSl].songs.length; iCounter++) {
    state.songlists[idxSl].songs[iCounter].songId === objSong.songId ? idxSong = iCounter : ""
  }
  let sng = state.songlists[idxSl].songs[idxSong]
  sng.title = objSong.title
  sng.artist = objSong.artist
  sng.notes = objSong.notes
  state.loadedSonglist = state.songlists[idxSl]
  // console.log(state.songlists[idxSl].songs[idxSong]);
  // state.songlists[idxSl].songs[idxSong] = objSong
  router.go(-1)
}

export const editSonglist = (objSonglist, state) => {
  let idx = getIndex(state.songlists, objSonglist.docId)
  state.songlists[idx] = objSonglist
}

export const updateSonglistName = (state, strName) => {
  state.loadedSonglist.name = strName
}